export default __webpack_public_path__ + "static/user1-2500e80e1cb384a32162c40f6f26b7f9.jpg";